"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemSettingsApiService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var helper_1 = require("../../helper");
var Http_service_1 = require("../http/Http.service");
/**
 * <br/>
 * **This service will be remove soon**, please use `LaunchDarklyService.getAllFeatureToggleSettings()` instead
 * <br/>
 */
var SystemSettingsApiService = /** @class */ (function () {
    function SystemSettingsApiService(httpService, seismicHelper) {
        this.httpService = httpService;
        this.seismicHelper = seismicHelper;
    }
    /**
     * @deprecated
     * <br/>
     * **This service will be remove soon**, please use `LaunchDarklyService.getAllFeatureToggleSettings()` instead
     * <br/>
     * Returns the launch darkly values for the specified array of keys
     * @param keys
     * @param defaultValue
     */
    SystemSettingsApiService.prototype.getFeatureToggleSettings = function (keys, defaultValue) {
        if (defaultValue === void 0) { defaultValue = false; }
        var ROOT_URL = this.seismicHelper.getRootURL();
        var url = ROOT_URL + "/api/systemsetting/v1/featureToggleSettings?defaultValue=" + defaultValue;
        return this.httpService.post(url, keys, {
            cache: 'local',
            cacheExpirationMinutes: 60,
        });
    };
    /**
     * @deprecated
     * <br/>
     * **This service will be remove soon**, please use `LaunchDarklyService.getAllFeatureToggleSettings()` instead
     * <br/>
     * Returns all the launch darkly values for every feature toggle
     */
    SystemSettingsApiService.prototype.getAllFeatureToggleSettings = function () {
        var ROOT_URL = this.seismicHelper.getRootURL();
        var url = ROOT_URL + "/api/systemsetting/v1/featureToggleSettings";
        return this.httpService.get(url, {
            cache: 'local',
            cacheExpirationMinutes: 60,
        });
    };
    SystemSettingsApiService = __decorate([
        CommonService_decorator_1.CommonService('SystemSettingsApiService'),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            helper_1.SeismicHelper])
    ], SystemSettingsApiService);
    return SystemSettingsApiService;
}());
exports.SystemSettingsApiService = SystemSettingsApiService;
//# sourceMappingURL=SystemSettingsApi.service.js.map